import { ValidationError } from '../ValidationError'
import { ValidatorAbstract } from '../ValidatorAbstract'
import { VALIDATION_MESSAGES } from '../messages'

class BottleBoxValidator extends ValidatorAbstract {
  validate () {
    const errors = []
    const { bottlesAmount, amount, bottleSize } = this.formModel

    if (!bottlesAmount) {
      errors.push(new ValidationError(2, VALIDATION_MESSAGES.BOTTLE_AMOUNT_REQUIRED))
    }

    if (!bottleSize.diameter || !bottleSize.height) {
      errors.push(new ValidationError(3, VALIDATION_MESSAGES.BOTTLE_SIZE_REQUIRED))
    }
    if (!amount) {
      errors.push(new ValidationError(7, VALIDATION_MESSAGES.QUANTITY_REQUIRED))
    }

    this.errors = errors
  }
}

export default BottleBoxValidator
